import { graphql } from 'gatsby';
import { Link, useIntl } from 'gatsby-plugin-intl';
import React from 'react';

import { CONTENTFUL_STORY_PHOTO_TYPE, QUICK_NAVIGATION_STORIES, ROUTES } from '../../utils';
import Layout from '../layout';
import RichTextRenderer from '../RichTextRenderer';
import SEO from '../seo';
import styles from './StoriesTemplate.module.scss';
import { ContentLayout, QuickBottomNavigationWrapper } from '..';

export const query = graphql`
	query($id: String!) {
		contentfulStory(id: { eq: $id }) {
			title
			description
			createdAt(formatString: "MMM D")
			contentPhotoType
			contentPhotoAsset {
				fluid {
					src
				}
			}
			content {
				json
			}
		}
	}
`;

const StoriesTemplate = ({ data }) => {
	const intl = useIntl();
	const { title, createdAt, content, contentPhotoType, contentPhotoAsset } = data.contentfulStory;
	return (
		<Layout>
			<SEO title={`Newsroom - story - ${title}`} />
			<div className={styles.container}>
				<QuickBottomNavigationWrapper optionalDataArray={QUICK_NAVIGATION_STORIES}>
					<ContentLayout>
						<h1>Stories</h1>
						<div className={styles.storyWrapper}>
							<div className={styles.row}>
								<p className={styles.date}>{createdAt}</p>
								<p>
									<Link to={ROUTES.newsroom.stories}>{intl.formatMessage({ id: 'close' })}</Link>
								</p>
							</div>
							<h2 className={styles.title}>{title}</h2>
							<RenderContent json={content.json} contentPhotoType={contentPhotoType} photoAsset={contentPhotoAsset} />
						</div>
						<p>
							<Link to={ROUTES.newsroom.stories}>{intl.formatMessage({ id: 'view_all_stories' })}</Link>
						</p>
					</ContentLayout>
				</QuickBottomNavigationWrapper>
			</div>
		</Layout>
	);
};

const RenderContent = ({ json, contentPhotoType, photoAsset }) => {
	if (contentPhotoType === CONTENTFUL_STORY_PHOTO_TYPE.noPhoto) {
		return <div className={styles.text}>{RichTextRenderer(json)}</div>;
	} else if (contentPhotoType === CONTENTFUL_STORY_PHOTO_TYPE.highPhoto) {
		return (
			<section className={styles.contentWrapper}>
				<div className={styles.text}>{RichTextRenderer(json)}</div>
				<div className={styles.photoWrapper}>
					<img className={styles.photo} src={photoAsset.fluid.src} alt="story photo" />
				</div>
			</section>
		);
	} else {
		return (
			<section className={styles.wideContentWrapper}>
				<img className={styles.photo} src={photoAsset.fluid.src} alt="story photo" />
				<div className={styles.text}>{RichTextRenderer(json)}</div>
			</section>
		);
	}
};

export default StoriesTemplate;
